import { render, staticRenderFns } from "./ServiceItemRenderer.vue?vue&type=template&id=d56cf05c&scoped=true&"
import script from "./ServiceItemRenderer.vue?vue&type=script&lang=js&"
export * from "./ServiceItemRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemRenderer.vue?vue&type=style&index=0&id=d56cf05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56cf05c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d56cf05c')) {
      api.createRecord('d56cf05c', component.options)
    } else {
      api.reload('d56cf05c', component.options)
    }
    module.hot.accept("./ServiceItemRenderer.vue?vue&type=template&id=d56cf05c&scoped=true&", function () {
      api.rerender('d56cf05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/ServiceItemRenderer.vue"
export default component.exports